package com.eladfinish.bible.contest

import dev.icerock.moko.resources.AssetResource
import kotlin.collections.List

internal object CommonMainAssets5 {
  internal val _1_bereshit_01_txt: AssetResource by lazy { init__1_bereshit_01_txt() }

  internal val _1_bereshit_02_txt: AssetResource by lazy { init__1_bereshit_02_txt() }

  internal val _1_bereshit_03_txt: AssetResource by lazy { init__1_bereshit_03_txt() }

  internal val _1_bereshit_04_txt: AssetResource by lazy { init__1_bereshit_04_txt() }

  internal val _1_bereshit_05_txt: AssetResource by lazy { init__1_bereshit_05_txt() }

  internal val _1_bereshit_06_txt: AssetResource by lazy { init__1_bereshit_06_txt() }

  internal val _1_bereshit_07_txt: AssetResource by lazy { init__1_bereshit_07_txt() }

  internal val _1_bereshit_08_txt: AssetResource by lazy { init__1_bereshit_08_txt() }

  internal val _1_bereshit_09_txt: AssetResource by lazy { init__1_bereshit_09_txt() }

  internal val _1_bereshit_10_txt: AssetResource by lazy { init__1_bereshit_10_txt() }

  internal val _1_bereshit_11_txt: AssetResource by lazy { init__1_bereshit_11_txt() }

  internal val _1_bereshit_12_txt: AssetResource by lazy { init__1_bereshit_12_txt() }

  internal val _1_bereshit_13_txt: AssetResource by lazy { init__1_bereshit_13_txt() }

  internal val _1_bereshit_14_txt: AssetResource by lazy { init__1_bereshit_14_txt() }

  internal val _1_bereshit_15_txt: AssetResource by lazy { init__1_bereshit_15_txt() }

  internal val _1_bereshit_16_txt: AssetResource by lazy { init__1_bereshit_16_txt() }

  internal val _1_bereshit_17_txt: AssetResource by lazy { init__1_bereshit_17_txt() }

  internal val _1_bereshit_18_txt: AssetResource by lazy { init__1_bereshit_18_txt() }

  internal val _1_bereshit_19_txt: AssetResource by lazy { init__1_bereshit_19_txt() }

  internal val _1_bereshit_20_txt: AssetResource by lazy { init__1_bereshit_20_txt() }

  internal val _1_bereshit_21_txt: AssetResource by lazy { init__1_bereshit_21_txt() }

  internal val _1_bereshit_22_txt: AssetResource by lazy { init__1_bereshit_22_txt() }

  internal val _1_bereshit_23_txt: AssetResource by lazy { init__1_bereshit_23_txt() }

  internal val _1_bereshit_24_txt: AssetResource by lazy { init__1_bereshit_24_txt() }

  internal val _1_bereshit_25_txt: AssetResource by lazy { init__1_bereshit_25_txt() }

  internal val _1_bereshit_26_txt: AssetResource by lazy { init__1_bereshit_26_txt() }

  internal val _1_bereshit_27_txt: AssetResource by lazy { init__1_bereshit_27_txt() }

  internal val _1_bereshit_28_txt: AssetResource by lazy { init__1_bereshit_28_txt() }

  internal val _1_bereshit_29_txt: AssetResource by lazy { init__1_bereshit_29_txt() }

  internal val _1_bereshit_30_txt: AssetResource by lazy { init__1_bereshit_30_txt() }

  internal val _1_bereshit_31_txt: AssetResource by lazy { init__1_bereshit_31_txt() }

  internal val _1_bereshit_32_txt: AssetResource by lazy { init__1_bereshit_32_txt() }

  internal val _1_bereshit_33_txt: AssetResource by lazy { init__1_bereshit_33_txt() }

  internal val _1_bereshit_34_txt: AssetResource by lazy { init__1_bereshit_34_txt() }

  internal val _1_bereshit_35_txt: AssetResource by lazy { init__1_bereshit_35_txt() }

  internal val _1_bereshit_36_txt: AssetResource by lazy { init__1_bereshit_36_txt() }

  internal val _1_bereshit_37_txt: AssetResource by lazy { init__1_bereshit_37_txt() }

  internal val _1_bereshit_38_txt: AssetResource by lazy { init__1_bereshit_38_txt() }

  internal val _1_bereshit_39_txt: AssetResource by lazy { init__1_bereshit_39_txt() }

  internal val _1_bereshit_40_txt: AssetResource by lazy { init__1_bereshit_40_txt() }

  internal val _1_bereshit_41_txt: AssetResource by lazy { init__1_bereshit_41_txt() }

  internal val _1_bereshit_42_txt: AssetResource by lazy { init__1_bereshit_42_txt() }

  internal val _1_bereshit_43_txt: AssetResource by lazy { init__1_bereshit_43_txt() }

  internal val _1_bereshit_44_txt: AssetResource by lazy { init__1_bereshit_44_txt() }

  internal val _1_bereshit_45_txt: AssetResource by lazy { init__1_bereshit_45_txt() }

  internal val _1_bereshit_46_txt: AssetResource by lazy { init__1_bereshit_46_txt() }

  internal val _1_bereshit_47_txt: AssetResource by lazy { init__1_bereshit_47_txt() }

  internal val _1_bereshit_48_txt: AssetResource by lazy { init__1_bereshit_48_txt() }

  internal val _1_bereshit_49_txt: AssetResource by lazy { init__1_bereshit_49_txt() }

  internal val _1_bereshit_50_txt: AssetResource by lazy { init__1_bereshit_50_txt() }

  internal fun values(): List<AssetResource> = listOf(_1_bereshit_01_txt, _1_bereshit_02_txt,
      _1_bereshit_03_txt, _1_bereshit_04_txt, _1_bereshit_05_txt, _1_bereshit_06_txt,
      _1_bereshit_07_txt, _1_bereshit_08_txt, _1_bereshit_09_txt, _1_bereshit_10_txt,
      _1_bereshit_11_txt, _1_bereshit_12_txt, _1_bereshit_13_txt, _1_bereshit_14_txt,
      _1_bereshit_15_txt, _1_bereshit_16_txt, _1_bereshit_17_txt, _1_bereshit_18_txt,
      _1_bereshit_19_txt, _1_bereshit_20_txt, _1_bereshit_21_txt, _1_bereshit_22_txt,
      _1_bereshit_23_txt, _1_bereshit_24_txt, _1_bereshit_25_txt, _1_bereshit_26_txt,
      _1_bereshit_27_txt, _1_bereshit_28_txt, _1_bereshit_29_txt, _1_bereshit_30_txt,
      _1_bereshit_31_txt, _1_bereshit_32_txt, _1_bereshit_33_txt, _1_bereshit_34_txt,
      _1_bereshit_35_txt, _1_bereshit_36_txt, _1_bereshit_37_txt, _1_bereshit_38_txt,
      _1_bereshit_39_txt, _1_bereshit_40_txt, _1_bereshit_41_txt, _1_bereshit_42_txt,
      _1_bereshit_43_txt, _1_bereshit_44_txt, _1_bereshit_45_txt, _1_bereshit_46_txt,
      _1_bereshit_47_txt, _1_bereshit_48_txt, _1_bereshit_49_txt, _1_bereshit_50_txt)
}

private fun init__1_bereshit_01_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-01.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-01.txt")

private fun init__1_bereshit_02_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-02.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-02.txt")

private fun init__1_bereshit_03_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-03.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-03.txt")

private fun init__1_bereshit_04_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-04.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-04.txt")

private fun init__1_bereshit_05_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-05.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-05.txt")

private fun init__1_bereshit_06_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-06.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-06.txt")

private fun init__1_bereshit_07_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-07.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-07.txt")

private fun init__1_bereshit_08_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-08.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-08.txt")

private fun init__1_bereshit_09_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-09.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-09.txt")

private fun init__1_bereshit_10_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-10.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-10.txt")

private fun init__1_bereshit_11_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-11.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-11.txt")

private fun init__1_bereshit_12_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-12.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-12.txt")

private fun init__1_bereshit_13_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-13.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-13.txt")

private fun init__1_bereshit_14_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-14.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-14.txt")

private fun init__1_bereshit_15_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-15.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-15.txt")

private fun init__1_bereshit_16_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-16.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-16.txt")

private fun init__1_bereshit_17_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-17.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-17.txt")

private fun init__1_bereshit_18_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-18.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-18.txt")

private fun init__1_bereshit_19_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-19.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-19.txt")

private fun init__1_bereshit_20_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-20.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-20.txt")

private fun init__1_bereshit_21_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-21.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-21.txt")

private fun init__1_bereshit_22_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-22.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-22.txt")

private fun init__1_bereshit_23_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-23.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-23.txt")

private fun init__1_bereshit_24_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-24.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-24.txt")

private fun init__1_bereshit_25_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-25.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-25.txt")

private fun init__1_bereshit_26_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-26.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-26.txt")

private fun init__1_bereshit_27_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-27.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-27.txt")

private fun init__1_bereshit_28_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-28.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-28.txt")

private fun init__1_bereshit_29_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-29.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-29.txt")

private fun init__1_bereshit_30_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-30.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-30.txt")

private fun init__1_bereshit_31_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-31.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-31.txt")

private fun init__1_bereshit_32_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-32.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-32.txt")

private fun init__1_bereshit_33_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-33.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-33.txt")

private fun init__1_bereshit_34_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-34.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-34.txt")

private fun init__1_bereshit_35_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-35.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-35.txt")

private fun init__1_bereshit_36_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-36.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-36.txt")

private fun init__1_bereshit_37_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-37.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-37.txt")

private fun init__1_bereshit_38_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-38.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-38.txt")

private fun init__1_bereshit_39_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-39.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-39.txt")

private fun init__1_bereshit_40_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-40.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-40.txt")

private fun init__1_bereshit_41_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-41.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-41.txt")

private fun init__1_bereshit_42_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-42.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-42.txt")

private fun init__1_bereshit_43_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-43.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-43.txt")

private fun init__1_bereshit_44_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-44.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-44.txt")

private fun init__1_bereshit_45_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-45.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-45.txt")

private fun init__1_bereshit_46_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-46.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-46.txt")

private fun init__1_bereshit_47_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-47.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-47.txt")

private fun init__1_bereshit_48_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-48.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-48.txt")

private fun init__1_bereshit_49_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-49.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-49.txt")

private fun init__1_bereshit_50_txt(): AssetResource = AssetResource(originalPath =
    js("require(\"./assets/allChapters/_1_bereshit-50.txt\")") as String, rawPath =
    "allChapters/_1_bereshit-50.txt")

public actual val SharedRes.assets.allChapters._1_bereshit_01_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_01_txt

public actual val SharedRes.assets.allChapters._1_bereshit_02_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_02_txt

public actual val SharedRes.assets.allChapters._1_bereshit_03_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_03_txt

public actual val SharedRes.assets.allChapters._1_bereshit_04_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_04_txt

public actual val SharedRes.assets.allChapters._1_bereshit_05_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_05_txt

public actual val SharedRes.assets.allChapters._1_bereshit_06_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_06_txt

public actual val SharedRes.assets.allChapters._1_bereshit_07_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_07_txt

public actual val SharedRes.assets.allChapters._1_bereshit_08_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_08_txt

public actual val SharedRes.assets.allChapters._1_bereshit_09_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_09_txt

public actual val SharedRes.assets.allChapters._1_bereshit_10_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_10_txt

public actual val SharedRes.assets.allChapters._1_bereshit_11_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_11_txt

public actual val SharedRes.assets.allChapters._1_bereshit_12_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_12_txt

public actual val SharedRes.assets.allChapters._1_bereshit_13_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_13_txt

public actual val SharedRes.assets.allChapters._1_bereshit_14_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_14_txt

public actual val SharedRes.assets.allChapters._1_bereshit_15_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_15_txt

public actual val SharedRes.assets.allChapters._1_bereshit_16_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_16_txt

public actual val SharedRes.assets.allChapters._1_bereshit_17_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_17_txt

public actual val SharedRes.assets.allChapters._1_bereshit_18_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_18_txt

public actual val SharedRes.assets.allChapters._1_bereshit_19_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_19_txt

public actual val SharedRes.assets.allChapters._1_bereshit_20_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_20_txt

public actual val SharedRes.assets.allChapters._1_bereshit_21_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_21_txt

public actual val SharedRes.assets.allChapters._1_bereshit_22_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_22_txt

public actual val SharedRes.assets.allChapters._1_bereshit_23_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_23_txt

public actual val SharedRes.assets.allChapters._1_bereshit_24_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_24_txt

public actual val SharedRes.assets.allChapters._1_bereshit_25_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_25_txt

public actual val SharedRes.assets.allChapters._1_bereshit_26_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_26_txt

public actual val SharedRes.assets.allChapters._1_bereshit_27_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_27_txt

public actual val SharedRes.assets.allChapters._1_bereshit_28_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_28_txt

public actual val SharedRes.assets.allChapters._1_bereshit_29_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_29_txt

public actual val SharedRes.assets.allChapters._1_bereshit_30_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_30_txt

public actual val SharedRes.assets.allChapters._1_bereshit_31_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_31_txt

public actual val SharedRes.assets.allChapters._1_bereshit_32_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_32_txt

public actual val SharedRes.assets.allChapters._1_bereshit_33_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_33_txt

public actual val SharedRes.assets.allChapters._1_bereshit_34_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_34_txt

public actual val SharedRes.assets.allChapters._1_bereshit_35_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_35_txt

public actual val SharedRes.assets.allChapters._1_bereshit_36_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_36_txt

public actual val SharedRes.assets.allChapters._1_bereshit_37_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_37_txt

public actual val SharedRes.assets.allChapters._1_bereshit_38_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_38_txt

public actual val SharedRes.assets.allChapters._1_bereshit_39_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_39_txt

public actual val SharedRes.assets.allChapters._1_bereshit_40_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_40_txt

public actual val SharedRes.assets.allChapters._1_bereshit_41_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_41_txt

public actual val SharedRes.assets.allChapters._1_bereshit_42_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_42_txt

public actual val SharedRes.assets.allChapters._1_bereshit_43_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_43_txt

public actual val SharedRes.assets.allChapters._1_bereshit_44_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_44_txt

public actual val SharedRes.assets.allChapters._1_bereshit_45_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_45_txt

public actual val SharedRes.assets.allChapters._1_bereshit_46_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_46_txt

public actual val SharedRes.assets.allChapters._1_bereshit_47_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_47_txt

public actual val SharedRes.assets.allChapters._1_bereshit_48_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_48_txt

public actual val SharedRes.assets.allChapters._1_bereshit_49_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_49_txt

public actual val SharedRes.assets.allChapters._1_bereshit_50_txt: AssetResource
  get() = CommonMainAssets5._1_bereshit_50_txt
